<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t("navigations.labs") }}</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="ibox-content py-2 mb-1">
        <div class="d-flex flex-column flex-lg-row justify-content-lg-start my-2 my-lg-0">
           <div class="col-lg-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.lab code") }}</label>
              <input
                type="text"
                class="form-control my-lg-0"
                v-model="labcode"
              />
            </div>
          </div>
          <div class="col-lg-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.lab Name") }}</label>
              <input
                type="text"
                class="form-control my-lg-0"
                v-model="labName"
              />
            </div>
          </div>
          <div class="col-lg-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.lab Type") }}</label>
             <select class="form-control" v-model="labType">
                        <option value="" >All</option>
                        <option value="Central Laboratory">Central Laboratory</option>
                        <option value="Local Laboratory">Local Laboratory</option>
                    </select>
            </div>
          </div>
         
        
            <span
            type="button"
              class="col-12 col-lg-3 save_btn w-100 align-self-end"
              @click.prevent="SearchButtonClicked()"
            >
              {{ $t("navigations.search") }}
            </span>            
        </div>
      </div>
        <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between">
                <h5>{{ $t("navigations.labs list") }}</h5>
                    <div class="d-flex">
        <div class="position-relative align-self-center mr-3">
          <img class="cursor-pointer" src="../../assets/img/create.png"  alt="Create study" @click.prevent="createlab(0)"/>
          <div class="tool-tip">{{ $t("navigations.create lab") }}</div>
        </div>
        
      
      </div>
            </div>
            
            <div class="ibox-content">
                <div class="text-center" v-if="showLoading === true">
                    <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
                    <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
                </div>
                <template v-else>
                    <div class="text-center" v-if="labList.length==0">
                        {{ $t('navigations.no data available') }}
                    </div>
                    <div v-else class="table-responsive">
                        <table class="table table-striped table-bordered dataTables">
                           <thead>
  <tr>
    <!-- <th class="sort_block" @click="SortSelected('studyName', 1)" id="1">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.study name") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th> -->

    <th class="sort_block" @click="SortSelected('labCode', 2)" id="2">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.lab code") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>

    <th class="sort_block" @click="SortSelected('labName', 3)" id="3">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.lab name") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>

    <th class="sort_block" @click="SortSelected('labType', 4)" id="4">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.lab type") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>

    <th class="sort_block" @click="SortSelected('location', 5)" id="5">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.location") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>

    <th class="sort_block" @click="SortSelected('countryCode', 6)" id="6">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.country code") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>

    <th class="sort_block" @click="SortSelected('status', 7)" id="7">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.status") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>

    <th class="text-center">{{ $t("navigations.edit") }}</th>
    <th class="text-center">{{ $t("navigations.manage test") }}</th>
    <th class="text-center">{{ $t("navigations.link site") }}</th>
    <th class="text-center">{{ $t("navigations.delete") }}</th>
  </tr>
                       </thead>

                            <tbody>
                                <tr v-for="lab in labList" :key="lab.labId">
                                    <!-- <td>{{ lab.studyRef }}</td> -->
                                    <td>{{ lab.labCode }}</td>
                                    <td>{{ lab.labName }}</td>
                                    <td>{{ lab.labType }}</td>
                                    <td>{{ lab.location }}</td>
                                    <td>{{ lab.countryCode }}</td>
                                    <td>{{ lab.status }}</td>
                                    <td class="text-center">
                          <i  class="fa fa-edit edit-delete" @click.prevent="editLab(lab.labId)"></i>
                        </td>
                                    <td class="text-center">
                          <i  class="fa fa-plus-circle edit-delete" @click.prevent="assignTest(lab.labCode)"></i>
                        </td>
                                   <td class="text-center">
                          <i  class="fa fa-plus-circle edit-delete" @click.prevent="linkSiteModal(lab.labCode)"></i>
                        </td>
                                   <td class="text-center">
                        <i
                            class="fa fa-trash edit-delete"
                            @click.prevent="deleteLabs(lab.labId)"
                          ></i
                          >
                        </td>
                                    <!-- <td>
                                        <div>
                                            <div>{{ lab.address.street }}</div>
                                            <div>{{ lab.address.city }}</div>
                                            <div>{{ lab.address.state }}</div>
                                            <div>{{ lab.address.countryCode }}</div>
                                            <div>{{ lab.address.postalCode }}</div>
                                        </div>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                        <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="labList.length!=0">
              <VPagination
                v-model="currentPage"
                :pages="totalItems"
                :range-size="1"
                active-color="#ededed"
                @update:modelValue="loadPage"
              />
            </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
   <linkSite
  v-if="showLinkSiteModal"
  :labCode="selectedLabCode"
  :studyId="selectedStudyId"
  @close="showLinkSiteModal = false"
 
/>

</template>
<script src="./labMaster.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
.wrap-table-cell{
  min-width: 70ch;
  text-wrap-mode:wrap

}
input :disabled{
  cursor:not-allowed;
  opacity:1;
}
.previousbtn,.nextbtn{
  margin:0;
  border-radius:0px;
  border:0.5px solid #eeeeee;
}
.page-links{
  border-radius:0px;
}
.form-select{
  border-radius:0!important;
}
.form-select:focus{
  border-color:#145faf!important;
  box-shadow: 0 0 0!important;
}
.position-relative img{
  width:20px;
}
.cursor-pointer {
  cursor: pointer;
}
.position-relative {
  position: relative;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -30px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip{
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.modal__container22 {
  width: 33%;
  max-width: 30%;
  position: fixed;
  height: 20% !important;
  margin-top: -550px !important;
  margin-left: 409px !important; 
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}
.modal__container23 {
  width: 66%;
    max-width: 62%;
    position: fixed;
    height: -14% !important;
    margin-top: -683px !important;
    margin-left: 140px !important;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    transition: all 0.3s ease-in-out 0s;
}
.scrollable3 {
  overflow-y: scroll;
  height: 250px;
}
.audit__details__modal__wrapper
{
  position: fixed;
  inset:0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index:3000
}
.audit__details__modal__container {
  width:min(90%,365px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
.audit__details__modal__title,
.audit__history__modal__title{
  background-color: var(--pop-up-background);
  color: #ffffff;
}
.heightBig
 {
  overflow-y: scroll;
  height: 250px;
}
.audit__history__modal__contents 
 {
  overflow-y: scroll;
  height: 404px;
}
.audit__history__modal__wrapper{
  position: fixed;
  inset:0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index:4000
}
.audit__history__modal__container
{
  width:min(45%,90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
</style>
